import HeartSolid from '@assets/icons/heart-solid.svg'
import { Icon } from './Icon'

export const HeartSolidIcon = Icon(HeartSolid)
